export const DURATION = {
  DEFAULT: 7000,
}
